import { useQuery } from "@tanstack/react-query";

import DataSvc from "../../../services/dataSvc";

const useLocation = (locationId: number | string) => {
  const query = useQuery(["location", locationId], async () => {
    return await DataSvc.getLocation(String(locationId));
  });

  return query;
};

export default useLocation;
